import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Case Sandberg
 * id A000BD20-147F-43FB-AD99-08AE6BA2E80B
 * name cards-variant
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-variant.svg
 * tags
 * - Gaming / RPG 
 */
export const CardsVariantIcon = createSvgIcon(<><path d="M5,2H19A1,1 0 0,1 20,3V13A1,1 0 0,1 19,14H5A1,1 0 0,1 4,13V3A1,1 0 0,1 5,2M6,4V12H18V4H6M20,17A1,1 0 0,1 19,18H5A1,1 0 0,1 4,17V16H20V17M20,21A1,1 0 0,1 19,22H5A1,1 0 0,1 4,21V20H20V21Z" /></>, 'CardsVariantIcon');
export default CardsVariantIcon